import { strings } from '@starryui10/localisation';
import React from 'react';
import { PageLoader } from './PageLoader';

export const ModuleLoading = () => {
    return <PageLoader caption={strings.Label_Loading} />;
};
